<main>
  <h1>Selectionner le type de verrouillage</h1>
  <div class="container">
    <mat-radio-group class="" [(ngModel)]="lockType" aria-label="Select an option">
      <mat-radio-button value="default">Mot de passe administrateur</mat-radio-button>
      <mat-radio-button value="custom">Mot de passe personnalisé</mat-radio-button>
      <mat-radio-button value="unlock">Désactiver</mat-radio-button>
    </mat-radio-group>
  </div>


  <ng-container *ngIf="lockType == 'custom'">
    <div class="container">
      <mat-label>Veuillez entrer un mot de passe</mat-label>
      <input matInput [(ngModel)]="lockPwd" required>
    </div>
  </ng-container>


  <div class="container">
    <button mat-raised-button color="primary" (click)="setLock()"> Valider </button>
    <button mat-raised-button color="warn" mat-dialog-close>Annuler</button>
  </div>
</main>
